import { cn } from '../../shared/lib/cn'

export function formatCurrency(value: number, compact = false) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: compact ? 0 : 2,
    notation: compact ? 'compact' : 'standard',
  }).format(value || 0)
}

export function formatPct(value: number) {
  return `${(value * 100).toFixed(1)}%`
}

export function varianceClass(value: number) {
  if (Math.abs(value) >= 0.25) return 'text-rose-700 dark:text-rose-300'
  if (Math.abs(value) >= 0.15) return 'text-amber-700 dark:text-amber-300'
  return 'text-emerald-700 dark:text-emerald-300'
}

export function statusBadgeClass(status: string) {
  return cn(
    'inline-flex items-center rounded-md px-2 py-1 text-xs font-semibold',
    status === 'hitl'
      ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300'
      : 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
  )
}
